
import Vue from 'vue';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('transition', { attrs: { name: 'fade' } }, [
    _vm.showForm
      ? _c('div', { staticClass: 'form-page' }, [
          _c(
            'button',
            {
              staticClass: 'close-button',
              attrs: { 'aria-label': 'Chiudi Form' },
              on: { click: _vm.closeModal },
            },
            [_vm._v(' ✕ ')],
          ),
          _c('iframe', {
            staticClass: 'full-screen-iframe',
            attrs: {
              src: 'https://forms.monday.com/forms/embed/4a50e5a06f52f675f27533f0d8c77110?r=euc1',
              frameborder: '0',
              allowfullscreen: '',
            },
          }),
        ])
      : _vm._e(),
  ]);
};
var staticRenderFns = [];

export default Vue.extend({
  render,
  staticRenderFns,
  name: 'FormPage',
  data(): { showForm: boolean } {
    return {
      showForm: true,
    };
  },
  methods: {
    closeModal(): void {
      this.showForm = false;
      this.$nextTick(() => {
        this.$router.go(-1);
      });
    },
    handleIframeMessage(event: MessageEvent): void {
      if (event.origin === 'https://forms.monday.com') {
        // Handle iframe events
      }
    },
  },
  mounted(): void {
    window.addEventListener('message', this.handleIframeMessage);
  },
  beforeDestroy(): void {
    window.removeEventListener('message', this.handleIframeMessage);
  },
});
